import Echo from "laravel-echo";
import {mapMutations, mapGetters} from "vuex";

window.Pusher = require('pusher-js');

export default {
    name: 'SocketMixin',
    computed: {
        ...mapGetters(['getUser', 'getEchoClient']),
    },
    methods: {
        ...mapMutations(['setEchoClient', 'setBonus']),
        connectToSocket() {
            this.setEchoClient(new Echo({
                broadcaster: 'pusher',
                key: '3c9bad44e5a802ac2de2',
                cluster: 'eu',
                authEndpoint: (process.env.NODE_ENV === 'development' ? 'http://api.monloco.my' : 'https://app.monloco.co') + '/broadcasting/auth',
                auth: {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.getters.getToken,
                    },
                },
            }));
            this.newBonusNotification();
            this.loadNewBonus();
        },
        newBonusNotification() {
            this.getEchoClient.private(`user.${this.getUser.id}`).listen('.new-bonus', () => {
                this.setBonus(true);
            });
        },
        loadNewBonus() {
            this.$api.notification.newBonus().then((data) => this.setBonus(data.new_bonus))
        }
    }
}
